{
  "name": "elohn-online",
  "version": "2024.1.1",
  "private": true,
  "engines": {
    "node": ">=18.12.0",
    "npm": ">=8.19.2"
  },
  "scripts": {
    "prepush": "concurrently npm:test:ci npm:lint:ci",
    "ng": "ng",
    "start": "check-engine && ng serve",
    "start:hmr": "echo '!!! Please use start:config:hmr !!!'",
    "start:config:hmr": "check-engine && ng serve --configuration=hmr",
    "start:config:hmr:de": "check-engine && ng serve --configuration=hmr,de",
    "start:config:hmr:fr": "check-engine && ng serve --configuration=hmr,fr",
    "start:config:hmr:it": "check-engine && ng serve --configuration=hmr,it",
    "start:config:de": "check-engine && ng serve --configuration=de",
    "start:config:fr": "check-engine && ng serve --configuration=fr",
    "start:config:it": "check-engine && ng serve --configuration=it",
    "clean": "rm -rf -- dist",
    "prebuild": "check-engine && npm run clean",
    "build": "ng build --configuration production --localize",
    "build:ci": "ng build --configuration production --localize --progress=false",
    "test": "check-engine && ng test --progress=true",
    "test:ci": "check-engine && ng test --configuration=test-ci --browsers=FirefoxHeadlessCI --progress=false --watch=false --code-coverage",
    "lint": "check-engine && concurrently \"npm:lint:ng\" \"npm:lint:style\" \"npm:lint:tsc\"",
    "lint:ci": "npm run lint",
    "lint:ng": "ng lint",
    "lint:style": "stylelint \"**/*.scss\"",
    "lint:style:fix": "stylelint --fix \"**/*.scss\"",
    "lint:tsc": "concurrently \"npm:lint:tsc:app\" \"npm:lint:tsc:spec\"",
    "lint:tsc:app": "tsc --pretty --noEmit --project ./tsconfig.app.json",
    "lint:tsc:spec": "tsc --pretty --noEmit --project ./tsconfig.spec.json",
    "update-translations": "ng extract-i18n",
    "patch-xmllint": "ts-node -P tsconfig.scripts.json scripts/patch-xmllint.ts",
    "postinstall": "npm run patch-xmllint"
  },
  "dependencies": {
    "@angular/animations": "^18.2.9",
    "@angular/common": "^18.2.9",
    "@angular/compiler": "^18.2.9",
    "@angular/core": "^18.2.9",
    "@angular/forms": "^18.2.9",
    "@angular/localize": "^18.2.9",
    "@angular/material": "^18.2.10",
    "@angular/material-moment-adapter": "^18.2.10",
    "@angular/platform-browser": "^18.2.9",
    "@angular/platform-browser-dynamic": "^18.2.9",
    "@angular/router": "^18.2.9",
    "@angular/service-worker": "^18.2.9",
    "angular-file": "^4.0.2",
    "blob-stream": "~0.1.3",
    "bwip-js": "^4.5.1",
    "chardet": "^2.0.0",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.1",
    "detect-browser": "^5.3.0",
    "dexie": "^4.0.10",
    "dexie-observable": "^4.0.1-beta.13",
    "file-saver": "^2.0.5",
    "from-xml": "^0.1.11",
    "immutable": "^4.3.7",
    "js2xmlparser": "^5.0.0",
    "jszip": "^3.10.1",
    "locale-id": "^1.1.2",
    "lodash-es": "^4.17.21",
    "moment": "^2.30.1",
    "ngx-extended-pdf-viewer": "^21.4.6",
    "ngx-progressbar": "12.0.2",
    "papaparse": "^5.4.1",
    "pdfkit": "0.15.1",
    "reflect-metadata": "^0.2.2",
    "svg-to-pdfkit": "^0.1.8",
    "text-encoding": "^0.7.0",
    "thenby": "^1.3.4",
    "to-xml": "^0.1.11",
    "tslib": "^2.8.1",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.10",
    "@angular-eslint/builder": "^18.4.0",
    "@angular-eslint/eslint-plugin": "^18.4.0",
    "@angular-eslint/eslint-plugin-template": "^18.4.0",
    "@angular-eslint/schematics": "^18.4.0",
    "@angular-eslint/template-parser": "^18.4.0",
    "@angular/cdk": "^18.2.10",
    "@angular/cli": "^18.2.10",
    "@angular/compiler-cli": "^18.2.9",
    "@angular/language-service": "^18.2.9",
    "@angularclass/hmr": "^3.0.0",
    "@types/blob-stream": "^0.1.33",
    "@types/file-saver": "^2.0.7",
    "@types/hammerjs": "^2.0.46",
    "@types/jasmine": "^3.10.18",
    "@types/jasminewd2": "^2.0.13",
    "@types/jszip": "^3.4.1",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^18.19.66",
    "@types/papaparse": "^5.3.15",
    "@types/pdfkit": "^0.13.6",
    "@types/text-encoding": "0.0.40",
    "@types/webpack-env": "^1.18.5",
    "@typescript-eslint/eslint-plugin": "^8.16.0",
    "@typescript-eslint/parser": "^8.16.0",
    "@typescript-eslint/utils": "^8.16.0",
    "arraybuffer-loader": "^1.0.8",
    "assert": "^2.1.0",
    "check-engine": "^1.14.0",
    "concurrently": "^9.1.0",
    "cross-env": "^7.0.3",
    "eslint-plugin-deprecation": "^3.0.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jasmine": "^4.2.2",
    "eslint-plugin-rxjs": "^5.0.3",
    "jasmine": "^3.99.0",
    "jasmine-core": "^3.99.1",
    "jasmine-spec-reporter": "^6.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-firefox-launcher": "^2.1.3",
    "karma-jasmine": "~4.0.2",
    "karma-jasmine-html-reporter": "^1.7.0",
    "karma-junit-reporter": "^2.0.1",
    "karma-mocha-reporter": "~2.2.5",
    "ng-extract-i18n-merge": "^2.12.0",
    "sass": "^1.81.0",
    "stylelint": "^16.10.0",
    "stylelint-config-recommended": "^14.0.1",
    "stylelint-config-recommended-scss": "^14.1.0",
    "stylelint-config-standard": "^36.0.1",
    "stylelint-scss": "^6.10.0",
    "ts-node": "^10.9.2",
    "typescript": "5.5.4",
    "url": "^0.11.4",
    "xmllint": "^0.1.1"
  },
  "homepage": "https://intra.dvbern.ch/display/ELOHN",
  "description": "Ausfüllen und Drucken eines Lohnausweis wie von der Eidgenössischen Steuerverwaltung vorgegeben",
  "keywords": [
    "elohn",
    "online",
    "Lohnausweis",
    "elohnausweis",
    "e-lohnausweis",
    "Certificat de salaire",
    "Certificato di salario",
    "Salary certificate"
  ],
  "license": "DV Bern AG Copyright",
  "author": {
    "name": "DV Bern AG",
    "url": "https://www.dvbern.ch"
  },
  "bugs": {
    "url": "https://support.dvbern.ch/projects/ELOHN/"
  }
}
